import {WorkerService} from './worker.service';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DicomParserHelper {
  private readonly tagsAsBytesToAnonymize: string[] = [
    '0010,0010', '0008,1010', '0008,1060', '0010,0032', '0010,1030',
    '0018,1000', '0008,0080', '0008,1030', '0008,1070',
    '0010,1090', '0018,1030', '0008,0081', '0008,1080',
    '0010,1000', '0010,2160', '0020,4000', '0008,0090', '0008,1040',
    '0008,2111', '0010,1001', '0010,2180', '0040,0275', '0008,0092',
    '0008,1048', '0010,0020', '0010,21B0', '0040,A730',
    '0008,0094', '0008,1050', '0010,0030', '0010,1020', '0010,4000',
    '0032,1032', '0008,1120', '0010,0021', '0010,0022', '0010,0024',
    '0010,0026', '0010,0027', '0010,0033', '0010,0034', '0010,0035',
    '0010,0050', '0010,0101', '0010,0102', '0010,1002', '0010,1005',
    '0010,1021', '0010,1040', '0010,1060', '0010,2154', '0010,2155',
    '0010,21F0', '0010,2201', '0010,2202', '0010,2203', '0010,2292',
    '0010,2293', '0012,0062', '0018,9313', '0018,9318', '0038,0400',
    '0038,0500', '0040,1004', '0072,0714', '0008,0080',
    '0008,0081', '0008,1010', '0008,1040', '0018,1000'];

  private webWorkerService: WorkerService;

  constructor(webWorker: WorkerService) {
    this.webWorkerService = webWorker;
    this.webWorkerService.initialize();
  }

  public createZip(files: any, name: string, id, queueId?: string): Observable<any> {
    return this.webWorkerService.invokeMessage({
      method: 'create_zip',
      path: files,
      name,
      id, queueId
    }) as Observable<any>;
  }

  public anonymizeFileInWebWorkerAndReturnArrayBuffer(arrayBuffer: ArrayBuffer, i: number, filename?: string, queueId?: string): Observable<[ArrayBuffer, string, string]> {
    const alocateMemory = filename;
    const anonymizationTags = this.flattenByteDicomTagsToAnonymize();
    const uint8Array = this.convertArrayBufferToUint8Array(arrayBuffer);
    return this.webWorkerService.invokeMessage({
      method: 'anonymize',
      path: alocateMemory,
      uint8Array,
      tags: anonymizationTags,
      name: filename,
      id: i,
      queueId
    }) as Observable<[ArrayBuffer, string, string]>;
  }

  public flattenByteDicomTagsToAnonymize() {
    return new Int16Array([].concat.apply([], this.tagsAsBytesToAnonymize.map(tag => this.parseTag(tag))));
  }

  private tagsAsHexToAnonymize(hexString: string): Uint8Array {
    const PREFIX = 'x';
    if (hexString.startsWith(PREFIX)) {
      hexString = hexString.slice(PREFIX.length);
    }
    if (hexString.length % 2 !== 0) {
      throw new Error('Must have an even number of hex digits to convert to bytes');
    }
    const numBytes = hexString.length / 2;
    const byteArray = new Uint8Array(numBytes);
    for (let i = 0; i < numBytes; i++) {
      byteArray[i] = this.parseTag(hexString)[i];
    }
    return byteArray;
  }

  private convertArrayBufferToUint8Array(data: ArrayBuffer | any): Uint8Array {
    if (Array.isArray(data) || data instanceof ArrayBuffer) {
      return new Uint8Array(data);
    }

    if (!(data instanceof Uint8Array)) {
      return new Uint8Array(data);
    }
  }

  private parseTag(tag: string): number[] {
    const v = tag.toLowerCase().match(/([0-9a-f]{2})/g);
    return [v[1], v[0], v[3], v[2]].map(f => parseInt(f, 16));
  }

}
